/* =====================================================================
   custom.js  -  ADA / WCAG fixes (The Sage Lifestyle)
   ===================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     1) Vitals Instagram Feed widget (3rd-party)
        Issue: "Check all visible page content is within defined landmark regions"
        Fix  : find the smallest element that contains BOTH the widget header
               and its posts, and turn it into a labelled region landmark.
     --------------------------------------------------------------- */
  function findCommonAncestor(a, b) {
    var node = a;
    while (node && node !== document.body) {
      if (node.contains(b)) return node;
      node = node.parentElement;
    }
    return null;
  }

  function fixInstagramLandmark() {
    var headers = document.querySelectorAll('.Vtl-InstagramFeedWidget__Header');
    headers.forEach(function (header) {
      var firstPost = document.querySelector('.Vtl-InstagramFeedLayout__Post');
      var root =
        header.closest('.Vtl-InstagramFeedWidget') ||
        (firstPost && findCommonAncestor(header, firstPost)) ||
        header.parentElement;

      if (!root || root === document.body || root === document.documentElement) return;
      if (root.getAttribute('data-ada-landmark') === 'done') return;

      // Already inside a real landmark? Nothing to do.
      if (root.closest('main, [role="main"], header, [role="banner"], nav, [role="navigation"], footer, [role="contentinfo"], aside, [role="complementary"], [role="region"][aria-label], [role="region"][aria-labelledby]')) {
        root.setAttribute('data-ada-landmark', 'done');
        return;
      }

      var title = header.querySelector('h1, h2, h3, h4');
      root.setAttribute('role', 'region');
      if (title) {
        if (!title.id) title.id = 'vtl-insta-title-' + Math.floor(Math.random() * 100000);
        root.setAttribute('aria-labelledby', title.id);
      } else {
        root.setAttribute('aria-label', 'Instagram feed');
      }
      root.setAttribute('data-ada-landmark', 'done');
    });
  }

  /* ---------------------------------------------------------------
     2) Mobile dock: buttons built from <div role="button">
        Give them keyboard support (Enter / Space).
     --------------------------------------------------------------- */
  document.addEventListener('keydown', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('.dock__item[data-action][role="button"]')) return;
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      el.click();
    }
  });

  /* ---------------------------------------------------------------
     3) Safety net: scrollable logo slider must be keyboard focusable
        (already fixed in perfume_logo.liquid, this covers cached/other pages)
     --------------------------------------------------------------- */
  function fixScrollableRegions() {
    document.querySelectorAll('.logo-slider-track').forEach(function (track) {
      if (!track.hasAttribute('tabindex')) track.setAttribute('tabindex', '0');
      if (!track.hasAttribute('role')) track.setAttribute('role', 'region');
      if (!track.hasAttribute('aria-label') && !track.hasAttribute('aria-labelledby')) {
        track.setAttribute('aria-label', 'Logo slider');
      }
    });
  }

  /* ---------------------------------------------------------------
     4) Wizybot chat widget (3rd-party)
        Issue: widget container + "!" notification badge sit outside landmarks
        Fix  : label the widget's top-level wrapper as a region landmark and
               hide the decorative "!" badge from assistive tech.
     --------------------------------------------------------------- */
  var LANDMARK_SEL = 'main, [role="main"], header, [role="banner"], nav, [role="navigation"], footer, [role="contentinfo"], aside, [role="complementary"], [role="region"][aria-label], [role="region"][aria-labelledby]';

  function fixChatWidgetLandmark() {
    var nodes = document.querySelectorAll(
      '#WizybotShopifyWidget__iframe__outter__id, .WizybotShopifyWidget__open__button__notification'
    );
    nodes.forEach(function (node) {
      // Decorative "!" badge: hide from screen readers
      if (node.classList.contains('WizybotShopifyWidget__open__button__notification')) {
        node.setAttribute('aria-hidden', 'true');
      }
      if (node.closest(LANDMARK_SEL)) return;

      // Climb to the top-level wrapper (direct child of <body>)
      var top = node;
      while (top.parentElement && top.parentElement !== document.body) top = top.parentElement;
      if (!top || top === node && node.parentElement !== document.body) return;

      // Safety: never label a wrapper that holds the real page content
      if (top.querySelector('main, header, footer, [role="main"]')) return;
      if (top.getAttribute('data-ada-landmark') === 'done') return;

      top.setAttribute('role', 'region');
      top.setAttribute('aria-label', 'Chat assistant');
      top.setAttribute('data-ada-landmark', 'done');
    });
  }

  /* ---------------------------------------------------------------
     Run now + whenever the 3rd-party widget injects its markup
     --------------------------------------------------------------- */
  function runAll() {
    fixInstagramLandmark();
    fixScrollableRegions();
    fixChatWidgetLandmark();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      scheduled = false;
      runAll();
    });
  }

  function init() {
    runAll();
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    // Vitals loads late; stop watching after 60s to keep the page light.
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// ===== ADA contrast fixes (Vtl app + fragrance notes) =====
(function () {
  var FIXES = [
    // selector, color, contrast on its background
    { sel: '.Vtl-ProductLabel__Text',                color: '#3F7658' }, // 5.33:1 on #fff
    { sel: '.Vtl-BundleSummary__OriginalPrice',      color: '#6b6b6b' }, // 5.33:1 on #fff
    { sel: '.Vtl-AiReviewSummary__label',            color: '#7a6030' }, // 5.68:1 on #fff9f4
    { sel: '.Vtl-AiReviewSummary__label-subtext',    color: '#6b6766' }, // 5.35:1 on #fff9f4
    { sel: '[class^="ai-fragrance-notes__tier-label-"]', color: '#4a6d5a' } // 5.55:1 on #fafafa
  ];

  function fixEl(el, color) {
    if (el.getAttribute('data-ada-done') === color) return;
    el.style.setProperty('color', color, 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.setAttribute('data-ada-done', color);
  }

  function run(root) {
    if (!root || root.nodeType !== 1) return;
    FIXES.forEach(function (f) {
      if (root.matches && root.matches(f.sel)) fixEl(root, f.color);
      root.querySelectorAll(f.sel).forEach(function (el) { fixEl(el, f.color); });
    });
  }

  function start() {
    run(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(run);
        // app re-styles an existing element: re-apply
        if (m.type === 'attributes' && m.target.hasAttribute('data-ada-done')) {
          var f = FIXES.find(function (x) { return m.target.matches(x.sel); });
          if (f) { m.target.removeAttribute('data-ada-done'); fixEl(m.target, f.color); }
        }
      });
    }).observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['style', 'class']
    });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();